import axios from 'axios';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:5000/api',
  withCredentials: true
});

export class ApiClient {
  constructor() {
    this.instance = axiosClient;
    this.instance.interceptors.request.use(config => {
      if (!config.url) {
        return config;
      }
  
      const currentUrl = new URL(config.baseURL + config.url);
      Object.entries(config.urlParams || {}).forEach(([k, v]) => {
        currentUrl.pathname = currentUrl.pathname.replace(`:${k}`, encodeURIComponent(v));
      });
      return {
        ...config,
        baseURL: `${currentUrl.protocol}//${currentUrl.host}`,
        url: currentUrl.pathname,
      };
    });
  }

  static getInstance() {
    if (!ApiClient.instance) {
      ApiClient.instance = new ApiClient();
    }
    return ApiClient.instance;
  }
  
  async get(path, requestData, handleError) {
    try {
      return await this.instance.get(path, requestData);
    } catch (error) {
      this.handleError(error, handleError);
      throw error;
    }
  }

  async put(path, data, params, handleError) {
    try {
      return await this.instance.put(path, data, params);
    } catch (error) {
      this.handleError(error, handleError);
      throw error;
    }
  }

  async post(path, data, params, handleError) {
    try {
      return await this.instance.post(path, data, params);
    } catch (error) {
      this.handleError(error, handleError);
      throw error;
    }
  }

  async delete(path, data, params, handleError) {
    try {
      return await this.instance.delete(path, data, params);
    } catch (error) {
      this.handleError(error, handleError);
      throw error;
    }
  }

  handleError(error, handleError = true) {
    if (handleError) {
      window.showGlobalToast(error.response.data.message || error.response.statusText, 'error');
      console.error('API Error:', error.response.data);
    }
  }

  login(email, password) {
    return axiosClient.post('/login', {
      email: email,
      password: password
    });
  };

  logoutUser() {
    return axiosClient.post('/logout');
  }
  
  getSession() {
    return axiosClient.get('/session');
  }
}
